import React, { useRef, useState } from 'react';
import { MainContainerItems, Title } from './index.styled';
import { useSelector, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import {
    clearSingleDropDownList,
    getDropdownValues,
    setReceiveSetsDetails,
    setSearchParam,
    SetNumberSelected,
    BatchNumberSelected,
} from 'src/pages/receiveSets/redux/actions';
import InputView from 'src/pages/receiveSets/components/common/InputView/InputView';
import AutoListItem from 'src/pages/receiveSets/components/common/AutoListItem/AutoListItem';
import { TerritorySelected } from 'src/pages/receiveSets/redux/actions/index.js';
import { debounce, logErrorToConsole } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export default function Territory({
    // territories,
    onTerritoryChange,
    setAccountValue,
    territoryValue,
    setTerritoryValue
    //accountId
}) {
    const dispatch = useDispatch();
    const { t: translation } = useTranslation();
    const territoryRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [selectedTerritory, setSelectedTerritory] = useState('');
    const territories = useSelector(
        (state) => state.receiveSetsDetailsDropdownsReducer.territories.items
    );
    const territoriesOptionLoading = useSelector(
        (state) => state.receiveSetsDetailsDropdownsReducer.territories.loading
    );
    const territoryObj = useSelector(
        (state) => state.receiveSetsListDataReducer.territory
    );

    const accountId = useSelector(
        (state) => state.receiveSetsReducer.surgeryDetails.accountId
    );

    const searchParam = useSelector(
        (state) => state.receiveSetsListDataReducer.searchParam
    );

    const onSelectItem = (data) => {
        setSelectedTerritory(data.terrirotryCode);
        onTerritoryChange(data.terrirotryCode);
        dispatch(TerritorySelected(data));
    };

    useEffectWithErrorLogging(() => {
        if (territories.length === 1 && !(searchParam?.length > 0)) {
            onSelectItem(territories[0]);
        }
    }, [territories]);

    const debouncedTerritoryList = useRef(
        debounce((option) => {
            dispatch(getDropdownValues(option));
        }, 300)
    ).current;

    const clearTerritorySelection = () => {
        setTerritoryValue('');
        setSelectedTerritory('');
        setAccountValue('');
        dispatch(setSearchParam(''));

        onTerritoryChange('');
        dispatch(TerritorySelected(''));
        dispatch(SetNumberSelected(''));
        dispatch(BatchNumberSelected(''));

        dispatch(
            clearSingleDropDownList({
                name: 'territories',
            })
        );
        dispatch(setReceiveSetsDetails({ territoryId: '', accountId: '' }));
    };

    const autoCompleteInputChange = (e, value, reason) => { 
        if (
            typeof value === 'string' &&
            value.trim().length === 0 &&
            (reason === 'clear' || reason === 'input')
        ) {
            clearTerritorySelection();
            return;
        }

        if (value){
            setTerritoryValue(value);
            if (value?.length > 0 && reason !== 'reset') {
                debouncedTerritoryList({
                    dropDownName: 'territories',
                    searchParam: value,
                    value: accountId?.accountId,
                });
                setOpen(true);
                dispatch(setSearchParam(value));
            } else {
                let terrirotryCode = '';
                dispatch(setSearchParam(''));
                onTerritoryChange(value);
            }
        }
        else if (reason==='clear'){
            clearTerritorySelection();
        }
    };
    const handleOnOpen = () => {
        if (selectedTerritory.length > 0) setOpen(true);
    };

    const updateSelectedProduct = (val, reason) => {
        if (val) {
            setTerritoryValue(val);
            //onTerritoryChange(selectedTerritory);
            // setOpen(false);
            // // showMessage(val.cfn);
            // const updatedProductList = [...productsList];
            // if (
            //     !updatedProductList.find((product) => val.cfn === product.cfn)
            // ) {
            //     updatedProductList.push({ ...val, quantity: 1 });
            //     // setProducts(updatedProductList);
            // }
        }
        else if(reason==='clear'){
            clearTerritorySelection();
        }
    };

    const handleOnfocus = (e) => {
        e.preventDefault(); 
        if (accountId && accountId?.accountId?.length === 0) {
            dispatch(getDropdownValues({ dropDownName: 'territories' }));
            setOpen(true);
        } else {
            dispatch(
                getDropdownValues({
                    dropDownName: 'territories',
                    value: accountId?.accountId,
                })
            ); 
            setOpen(true);
        }
    };

    return (
        <MainContainerItems setMarginBottom={true} width={'100%'}>
            <Title
                showAstrisk={
                    // mandatoryFields.hasOwnProperty('territoryId')
                    // ?
                    true
                    //: false
                }
            >
                {translation('equity.dTerritory.territory.title')}
            </Title>
            {/* {territories && territories.length > 0 ? ( */}
            <>
                {/* <Select
                        value={
                            
                            territoryId
                                ?.length > 0 ? territoryId:''
                              
                        }
                        options={territories}
                        onChange={onTerritoryChange}
                        placeholder={'Enter Territory'}
                        optionValue="terrirotryCode"
                        optionLabel="terrirotryName"
                        name="territoryId"
                        
                        itemTemplate={(option) => {
                            if (option) {
                                return (
                                    <SelectedCurrentLocation
                                        whiteSpace={'pre-wrap'}
                                    >
                                        {option.terrirotryName}
                                    </SelectedCurrentLocation>
                                );
                            }
                        }}
                        valueTemplate={(option, props) => {
                            if (option) {
                                return (
                                    <SelectedCurrentLoc
                                        width={
                                            window.innerWidth <= '360'
                                                ? '215px'
                                                : '100%'
                                        }
                                    >
                                        {option.terrirotryName}
                                    </SelectedCurrentLoc>
                                );
                            }
                            return <div>{props.placeholder}</div>;
                        }}
                    /> */}
                {territories && territories.length === 1 && !(searchParam?.length > 0)? (
                    <label
                        style={{
                            fontFamily: 'AvenirNextWorld Regular',
                            fontSize: '16px',
                            color: '#202124',
                            wordBreak: 'break-word',
                        }}
                    >
                        {territories && territories[0]?.cfn}
                    </label> 
                ) : ( 
                    <AutoComplete
                        inputRef={territoryRef} 
                        showScrollBar={true}
                        disableClearable={false}
                        isFullWidth={true} 
                        options={territories || []}
                        value={territoryObj}
                        inputValue={territoryObj?.terrirotryName || territoryValue?.terrirotryName || 
                            (typeof territoryValue === 'string' ? territoryValue : '') ||
                        ''}
                        clearOnBlur={false}
                        filterField={'terrirotryName'}
                        itemTemplate={(option) => {
                            return (
                                <AutoListItem
                                    data={option}
                                    titleField={'territoryId'}
                                    onSelectItem={onSelectItem}
                                    padding={'10px'}
                                    fSize={'16px !important'}
                                    fontFamily={'AvenirNextWorld Regular'}
                                    bBottom={'none'}
                                    overflowX={'hidden'}
                                    wordBreak={'break-word'}
                                />
                            );}
                        }
                        onChange={(value, reason) => { 
                            if(reason==='clear'){
                                dispatch(TerritorySelected(''));
                                dispatch(
                                getDropdownValues({
                                    dropDownName: 'territories',
                                })
                                );
                            }
                            updateSelectedProduct(value, reason);
                            if(value==='') setOpen(true);
                        }}
                        hideNoOptionText={false}
                        placeholder={translation(
                                    'receiveSets.ReceiveSetsLoc.Territory.territoryName'
                                )}
                        optionValue='terrirotryCode' 
                        field="territoryName" 
                        id={'receiveSets-receiveSetsLoc-territory-territory'}
                        onInputChange={(e, value, reason) =>
                            autoCompleteInputChange(e, value, reason)
                        }
                        loading={territoriesOptionLoading}
                        noOptionsText={
                            !territoriesOptionLoading &&
                            territories?.length === 0
                                ? translation(
                                      'calendar.filterResultsPanel.noOptionText'
                                  )
                                : territoriesOptionLoading &&
                                  translation('common.loadingText')
                        }
                        onFocus={(event) => handleOnfocus(event)} 
                        onOpen={handleOnOpen}
                        open={open}
                        onClose={() => {
                            try {
                            setOpen(false);
                             } catch (error) {
                                 logErrorToConsole(error);
                             }
                        }}
                        readOnly={territoryObj}
                        detailsMargin
                        marginLeft={'1.5px'}
                        zIndex={'99999'}
                    />
                )}
            </>
            {/* ) : (
                <>
                    <Subtitle>
                        {territories.length >= 1
                            ? territories[0].terrirotryName
                            : ''}
                    </Subtitle>
                </>
            )
            } */}
        </MainContainerItems>
    );
}
